import { optionStore } from './stores'
import { update } from './post'

export function init() {
  const ignores = window.localStorage.getItem("Ignores")
  if (ignores) {
    ignores.split(',').forEach(publisher => optionStore.hidePublisher(Number(publisher)))
  }

  const rankingType = window.localStorage.getItem("RankingType")
  if (rankingType) {
    setRankingType(rankingType)
  }
  else {
    setRankingType(0)
  }
}

export function getIgnoresStr() {
  return [...optionStore.ignores].join(',')
}

export function getPublisherVisible(value) {
  return !optionStore.ignores.has(value)
}

export function togglePublisherVisible(publisher) {
  if (optionStore.ignores.has(publisher)) {
    console.log('option.showPublisher')
    optionStore.showPublisher(publisher)
  }
  else {
    console.log('option.hidePublisher')
    optionStore.hidePublisher(publisher)
  }
  
  saveOption("Ignores", getIgnoresStr())
}

// saveOption 은 설정 저장 실패가 앱 로드를 막지 않게 한다. init() 이 모듈 최상위에서 돌고
// 그 안에서 setRankingType 이 불리므로, 여기서 예외가 나가면 번들 평가가 끊겨 화면 전체가
// 백지가 된다. 게다가 stores/option.js 의 초기값이 없는 키(RankingType.DAYILY)를 참조해
// undefined 라, setRankingType 의 조기 반환이 걸리지 않아 이 저장은 페이지를 열 때마다 돈다.
function saveOption(key, value) {
  try {
    window.localStorage.setItem(key, value)
  } catch (e) {
    console.error(`설정 저장 실패 (${key}):`, e)
  }
}

export function getRankingType() {
  return optionStore.rankingType
}

export function setRankingType(value) {
  if (optionStore.rankingType == value) {
    return
  }
  
  console.log(`option.setRankingType [${optionStore.rankingType} -> ${value}]`)

  optionStore.setRankingType(value)
  saveOption("RankingType", value)

  update()
}

init()